import { useMemo } from 'react';
import { useApp } from '../../context/AppContext';
import { dateKey, sortDayEvents } from '../../utils/dateUtils';

/**
 * "今日の予定" section.
 * 0 events  -> empty-state message
 * 1-2       -> horizontal scroll cards (icon / time / title only)
 * 3+        -> compact vertical list
 * Always sorted: all-day first, then by start time.
 */
export default function TodaySchedule() {
  const { today, events } = useApp();

  const todayEvents = useMemo(() => {
    const key = dateKey(today);
    return sortDayEvents(events.filter((e) => e.date === key));
  }, [events, today]);

  return (
    <>
      <div className="section-label">
        今日の予定 <span className="count-badge">{todayEvents.length}件</span>
      </div>

      {todayEvents.length === 0 && (
        <div className="today-empty">今日は予定はありません😊</div>
      )}

      {todayEvents.length > 0 && todayEvents.length <= 2 && (
        <div className="today-scroller">
          {todayEvents.map((ev) => (
            <div className="today-card" key={ev.id}>
              <div className="icon">{ev.icon}</div>
              <div className="text">
                <div className="time">{ev.allDay ? '終日' : ev.start}</div>
                <div className="title">{ev.title}</div>
              </div>
            </div>
          ))}
        </div>
      )}

      {todayEvents.length >= 3 && (
        <div className="today-list">
          {todayEvents.map((ev) => (
            <div className="today-list-row" key={ev.id}>
              <div className="icon">{ev.icon}</div>
              <div className="time">{ev.allDay ? '終日' : ev.start}</div>
              <div className="title">{ev.title}</div>
            </div>
          ))}
        </div>
      )}
    </>
  );
}
